import axios from 'axios';

export const fetchSessionInfo = async () => {
  const response = await axios.get('/mychart/embedded/session_info');
  return response.data;
};
